import {axios} from "@/api/config";
// 查询检查项列表
export function listSpecialDanger(params) {
  return axios.get('/hiddenSpecialDanger/list', params,true);
}

// 查询检查项详细
export function getSpecialDanger(recordId) {
  return axios.get(`/hiddenSpecialDanger/${recordId}`, recordId, true)
}

// 新增检查项
export function addSpecialDanger(params) {
  return axios.post('/hiddenSpecialDanger/add', params, false);
}

// 修改检查项
export function updateSpecialDanger(params) {
  return axios.post('/hiddenSpecialDanger/edit', params, false);
}

// 删除检查项
export function delSpecialDanger(recordId) {
  return axios.delete(`/hiddenSpecialDanger/${recordId}`, true)
}
